import axios from 'axios'

const urlBase = 'https://vyhzkzl1q7.execute-api.us-east-1.amazonaws.com/desa/api';
const urlBaseSelect = 'https://15fasj3enj.execute-api.us-east-1.amazonaws.com/desa/api';
/**
 * @param {string}  url url a la cual consultar
 * esta funcion detecta si es una nueva url base (comienza con http:// o https://).
 * en caso de ser asi, retorna la url. en caso contrario, se asume que es un fragmento
 * de path por lo que se concatena con la constante urlBase
 **/
const readUrl = (url = '') =>
    url.startsWith('http://') || url.startsWith('https://') ? url : `${urlBase}/${url}`
const readUrlSelect = (url = '') =>
    url.startsWith('http://') || url.startsWith('https://') ? url : `${urlBaseSelect}/${url}`
    /**
 * Instancia personalizada de axios para agregar interceptores 
 */
const instance = axios.create();

const get = (url = '', headers = {}) => instance.get(readUrl(url), {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const getSelect = (url = '', headers = {}) => instance.get(readUrlSelect(url), {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const post = (url = '', body = {}, headers = {}) => instance.post(readUrl(url), body, {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const postLogin = (url = '', body = {}, headers = {}) => instance.post(readUrlSelect(url), body, {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const client = {
    instance: instance,
    get: get,
    post: post,
    getSelect: getSelect,
    postLogin: postLogin
}

export default client;
